import { get } from 'lodash-es';

const byImageResizeUrl = (state: any) =>
  get(state, 'runtimeConfig.imageResizeUrl');

export default byImageResizeUrl;
